<div class="notification-wrapper" *transloco="let t">
  <xt-portal-button
    icon="notifications"
    color="none"
    [ariaLabel]="t('app.profile.notificationsHeader')"
    width="small"
    (clickEvent)="openDialog()"
    [xTentionDummyCypress]="'notifications.indicator.dialog.open'"
    />
    @if (hasUnreadNotifications$ | async) {
      <span class="notification"></span>
    }
  </div>
